import { Component, Input } from '@angular/core';

@Component({
    selector: 'emm-created-date-display',
    templateUrl: './created-date.component.html',
    styleUrls: ['./created-date.component.scss'],
    standalone: false
})
export class CreatedDateComponent {
    @Input() createdDate: string | Date;
    @Input() createdBy: string;
}
